import styled from "styled-components";
import Colors from "../../../themes/Colors";

export const SectionContainer = styled.div`
  width: 100%;
  margin: 0 0 20px 0;
  display: flex;
  flex-direction: column;
  align-items: left;
`;

export const CoberturasList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const CoberturaItem = styled.div`
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 10px;
  margin-bottom: 10px;
  background-color: #fafafa;
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 12px;
`;

export const CoberturaInputsRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr auto;
  gap: 15px;
  align-items: end;
  width: 100%;
`;

export const CoberturaInputsRowPaquete = styled.div`
  display: grid;
  grid-template-columns: 200px 1fr 1fr auto;
  gap: 15px;
  align-items: end;
  width: 100%;
`;

export const CoberturaInputsRowArs = styled.div`
  display: grid;
  grid-template-columns: 300px 300px auto;
  gap: 15px;
  align-items: end;
  width: 100%;
`;

export const InputGroup = styled.div`
  flex: 1;
  min-width: 0;
`;

export const InputGroupCobertura = styled.div`
  width: 100%;
`;

export const InputGroupCoberturaPaquete = styled.div`
  width: 100%;
`;

export const InputGroupMedico = styled.div`
  width: 100%;
`;

export const InputGroupMedicoPaquete = styled.div`
  width: 100%;
`;

export const InputGroupEspecialidad = styled.div`
  width: 100%;
`;

export const ButtonGroup = styled.div`
  display: flex;
  align-items: center;
  justify-content: end;
  height: 100%;
`;

export const ModalidadSection = styled.div`
  display: flex;
  gap: 20px;
  align-items: center;
  margin-top: 10px;
  padding: 10px;
  background-color: #f5f5f5;
  border-radius: 6px;
  border: 1px solid #e0e0e0;
`;

export const ModalidadRow = styled.div`
  display: flex;
  gap: 20px;
  align-items: center;
  margin-top: 10px;
  padding: 10px;
  background-color: #f5f5f5;
  border-radius: 6px;
  border: 1px solid #e0e0e0;
`;

export const ModalidadLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  font-size: 13px;
  
  input[type="radio"] {
    margin: 0;
  }
`;

export const ModalidadText = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: #333;
  margin: 0;
`;

export const PaqueteFieldsContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 15px;
  align-items: end;
  width: 100%;
`;

export const InputFieldContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const InputLabel = styled.span`
  font-size: 12px;
  font-weight: 500;
  color: #333;
  margin-bottom: 4px;
  display: block;
`;

export const SimpleInput = styled.input`
  height: 32px;
  padding: 8px 12px;
  font-size: 13px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  outline: none;
  transition: border-color 0.2s ease;

  &:focus {
    border-color: ${Colors.primary};
  }

  &::placeholder {
    color: #999;
  }
`;

export const EmptyStateContainer = styled.div`
  text-align: center;
  padding: 40px 20px;
  color: #666;
  background-color: #f9f9f9;
  border-radius: 8px;
  border: 1px dashed #ddd;
`;

export const EmptyStateText = styled.div`
  font-size: 14px;
  color: #666;
`;

export const EmptyStateSubtext = styled.div`
  font-size: 12px;
  color: #999;
  margin-top: 5px;
`;

export const SeparatorContainer = styled.div`
  height: 10px;
`;

export const AddButtonContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-top: 10px;
`;

export const AddButtonStyles = {
  fontSize: "12px",
  padding: "6px 12px",
  height: "40px",
  width: "200px"
};

export const DeleteButtonStyles = {
  fontSize: "12px",
  padding: "6px 12px",
  minWidth: "80px"
};
